export default __webpack_public_path__ + "static/media/bail-proj-text.43bc1710.png";